/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';

type ImgProps = React.ClassAttributes<HTMLImageElement> &
  React.ImgHTMLAttributes<HTMLImageElement>;

const LazyImage: React.FC<ImgProps> = ({ src, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const fallback = '/assets/svg/logos/logo.svg';
  // Miniature ultra-réduite (adapte selon ton service d’images)
  const reducedSize =
    src ? `${src.split('?')[0]}?tr=w-4,h-4` : `${fallback}?tr=w-4,h-4`;

  useEffect(() => {
    setIsLoaded(false);
    if (typeof window === 'undefined') return;     // SSR guard
    if (!src) {
      setIsLoaded(true);
      return;
    }

    const img = new Image();
    const onLoad = () => setIsLoaded(true);
    const onError = () => setIsLoaded(true);       // on “échoue” en affichant l’original/fallback

    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);
    img.src = src;

    // Cleanup: évite setState après unmount
    return () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);
    };
  }, [src]);

  return (
    <div className={!isLoaded ? 'position-relative' : ''}>
      {!isLoaded && <div className="lds-dual-ring" />}
      <img
        src={isLoaded ? src || fallback : reducedSize}
        loading="lazy"
        {...props}
      />
    </div>
  );
};

export default LazyImage;
